import { render, staticRenderFns } from "./ContactTypeCustomFieldsForm.vue?vue&type=template&id=11ca9c10&scoped=true&"
import script from "./ContactTypeCustomFieldsForm.vue?vue&type=script&lang=js&"
export * from "./ContactTypeCustomFieldsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ca9c10",
  null
  
)

export default component.exports